import React from "react";
import { FormattedMessage } from "react-intl";
import { Link } from "react-router-dom";
import moment from "moment";

import config from "../../../helpers/config";

export default React.memo(function Footer(props) {

  return (
    <footer className="footer">
      <div className="footer-top">
        <div className="container container-1120">
          <div className="row gy-8">
            <div className="col-lg-3">
              <div className="footer-logo">
                <img src="images/logo.svg" className="img-fluid" alt="Enrich B2B" />
              </div>
            </div>
            <div className="col-lg-3">
              <div className="footer-link">
                <h5 className="heading-06 fw-semibold text-uppercase text-grey-63 mb-6">
                  <FormattedMessage id="footer.public.legal" defaultMessage="Legal" />
                </h5>
                <ul className="list-unstyled">
                  <li>
                    <Link to="#">
                      <FormattedMessage id="footer.public.links.privacy_policy" defaultMessage="Privacy Policy" />
                    </Link>
                  </li>
                  <li>
                    <Link to="#">
                      <FormattedMessage id="footer.public.links.data_processing_addendum" defaultMessage="Data Processing Addendum" />
                    </Link>
                  </li>
                  <li>
                    <Link to="/terms-and-conditions">
                      <FormattedMessage id="footer.public.links.terms_of_service" defaultMessage="Terms of Service" />
                    </Link>
                  </li>
                </ul>
              </div>
            </div>
            <div className="col-lg-3">
              <div className="footer-link">
                <h5 className="heading-06 fw-semibold text-uppercase text-grey-63 mb-6">
                  <FormattedMessage id="footer.public.company" defaultMessage="Company" />
                </h5>
                <ul className="list-unstyled">
                  <li>
                    <Link to="#">
                      <FormattedMessage id="footer.public.links.about" defaultMessage="About" />
                    </Link>
                  </li>
                  <li>
                    <Link to="/contact-us">
                      <FormattedMessage id="footer.public.links.contact_us" defaultMessage="Contact Us" />
                    </Link>
                  </li>
                </ul>
              </div>
            </div>
            <div className="col-lg-3">
              <div className="footer-link">
                <h5 className="heading-06 fw-semibold text-uppercase text-grey-63 mb-6">
                  <FormattedMessage id="footer.public.developers" defaultMessage="Developers" />
                </h5>
                <ul className="list-unstyled">
                  <li>
                    <a href={config.getPublicBackendURL(true, true, "/swagger/index.html")} target="_blank" rel="noopener noreferrer">
                      <FormattedMessage id="footer.public.links.api_portal" defaultMessage="API Portal" />
                    </a>
                  </li>
                  <li>
                    <a href={config.getPublicBackendURL(true, true, "/swagger/index.html")} target="_blank" rel="noopener noreferrer">
                      <FormattedMessage id="footer.public.links.api_documentation" defaultMessage="API Documentation" />
                    </a>
                  </li>
                  <li>
                    <Link to="#">
                      <FormattedMessage id="footer.public.links.service_status" defaultMessage="Service Status" />
                    </Link>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="footer-bottom">
        <div className="container container-1120">
          <div className="row align-items-center">
            <div className="col-lg-9 mx-auto">
              <div className="footer-copyright text-center">
                <p>
                  <FormattedMessage
                    id="footer.public.copyright_text"
                    defaultMessage="© {year} EnrichB2B All rights reserved. EnrichB2B is a trading name of Webstem LTD. LinkedIn is a registered trademark of LinkedIn Corporation and is protected by law under laws. Google and LinkedIn are not affiliated with EnrichB2B."
                    values={{ year: moment().format("YYYY") }}
                  />
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>

  );
});